export default __webpack_public_path__ + "static/media/logoNoBackground.679e4262.png";